import { useLanguage } from "@/i18n/LanguageContext";
import { LOCALES } from "@/i18n/config";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Check, Globe } from "lucide-react";

export function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();
  const active = LOCALES.find((l) => l.code === language) ?? LOCALES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-1.5 text-xs font-medium" aria-label="Change language">
          <Globe className="h-4 w-4" />
          <span className="uppercase">{active.label ?? active.code}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-44 bg-popover z-50">
        {LOCALES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setLanguage(l.code)}
            className="justify-between gap-4"
            dir={l.dir}
          >
            <span>{l.native}</span>
            <span className="flex items-center gap-2">
              <span className="text-xs uppercase text-muted-foreground">{l.label ?? l.code}</span>
              {l.code === language && <Check className="h-3.5 w-3.5" />}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
